@if (visible() && kind() !== 'none') {
<div
  class="card card-details meeting-status-card shadow-none"
  [ngClass]="{
    'tone-warning': kind() === 'pending',
    'tone-info': kind() === 'scheduled'
  }"
>
  <div class="card-body d-flex align-items-start gap-3 p-3">
    <div class="status-icon-wrap">
      <div class="status-icon-inner">
        <i class="fas" [ngClass]="iconClass()"></i>
      </div>
    </div>

    <div class="flex-grow-1">
      <div
        class="d-flex align-items-start justify-content-between flex-wrap gap-2"
      >
        <div class="d-flex flex-column">
          <div class="status-title">
            {{
              "admin.scheduleMeeting.meetingStatus." + kind() + ".title"
                | translate
            }}
          </div>
          <div class="status-subtitle">
            {{
              "admin.scheduleMeeting.meetingStatus." + kind() + ".subtitle"
                | translate : { when: formattedAt() }
            }}
          </div>
        </div>

        <div class="d-flex align-items-start gap-2">
          <button
            class="btn btn-outline-danger btn-sm"
            type="button"
            (click)="onCancel()"
            [disabled]="loading()"
          >
            {{ "admin.scheduleMeeting.actions.cancelMeeting" | translate }}
          </button>

          @if (scheduledAt()) {
          <button
            class="btn btn-primary btn-sm"
            type="button"
            (click)="onDone()"
            [disabled]="loading()"
          >
            {{ "admin.scheduleMeeting.actions.completeMeeting" | translate }}
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
